<div class="layout-topbar">
    <!-- Burger far left: the sidebar's handle sits where the hand expects it. -->
    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <!-- The brand, centered whatever lives on either side. -->
    <a class="layout-topbar-logo topbar-logo-centered" routerLink="">
        <img src="assets/layout/images/logo-smatchy.png" alt="Smatchy" class="topbar-logo-mark">
        <span>SMATCHY</span>
    </a>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <!-- The two spaces, one keystroke apart, each wearing its pending count. -->
        <a class="topbar-space-btn" routerLink="/synthese" routerLinkActive="is-active">
            <i class="pi pi-compass"></i>
            <span>{{ 'topbar.synthese' | translate }}</span>
        </a>
        <a class="topbar-space-btn" routerLink="/a-traiter" routerLinkActive="is-active">
            <i class="pi pi-check-square"></i>
            <span>{{ 'topbar.todo' | translate }}</span>
            <span class="topbar-badge" *ngIf="todoBadge > 0">{{ todoBadge > 99 ? '99+' : todoBadge }}</span>
        </a>
        <a class="topbar-space-btn" routerLink="/studio" routerLinkActive="is-active">
            <i class="pi pi-megaphone"></i>
            <span>{{ 'topbar.studio' | translate }}</span>
            <span class="topbar-badge" *ngIf="studioBadge > 0">{{ studioBadge > 99 ? '99+' : studioBadge }}</span>
        </a>

        <!-- The language wears its flag: French tricolour in FR, Union Jack in EN. -->
        <button
            class="p-link layout-topbar-button topbar-flag-btn"
            type="button"
            (click)="languageService.toggle()"
            [attr.aria-label]="(languageService.current() === 'fr' ? 'topbar.switchToEnglish' : 'topbar.switchToFrench') | translate"
            [title]="(languageService.current() === 'fr' ? 'topbar.switchToEnglish' : 'topbar.switchToFrench') | translate">
            <svg *ngIf="languageService.current() === 'fr'" class="topbar-flag" viewBox="0 0 30 20" aria-hidden="true">
                <rect width="10" height="20" fill="#0055A4"/><rect x="10" width="10" height="20" fill="#fff"/><rect x="20" width="10" height="20" fill="#EF4135"/>
            </svg>
            <svg *ngIf="languageService.current() !== 'fr'" class="topbar-flag" viewBox="0 0 30 20" aria-hidden="true">
                <rect width="30" height="20" fill="#012169"/>
                <path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" stroke-width="4"/>
                <path d="M0,0 L30,20 M30,0 L0,20" stroke="#C8102E" stroke-width="2"/>
                <path d="M15,0 V20 M0,10 H30" stroke="#fff" stroke-width="7"/>
                <path d="M15,0 V20 M0,10 H30" stroke="#C8102E" stroke-width="4"/>
            </svg>
            <span class="uppercase">{{ languageService.current() }}</span>
        </button>
    </div>
</div>
